import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Variant = 'green' | 'red' | 'amber' | 'neutral' | 'purple';

const VARIANTS: Record<Variant, string> = {
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  red: 'bg-rose-50 text-rose-700 ring-rose-600/20',
  amber: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  neutral: 'bg-slate-100 text-slate-600 ring-slate-500/20',
  purple: 'bg-brand-purple/10 text-brand-purple ring-brand-purple/20',
};

const DOT: Record<Variant, string> = {
  green: 'bg-emerald-500',
  red: 'bg-rose-500',
  amber: 'bg-amber-500',
  neutral: 'bg-slate-400',
  purple: 'bg-brand-purple',
};

export function Badge({
  variant = 'neutral',
  dot = false,
  children,
  className,
}: {
  variant?: Variant;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ring-inset',
        VARIANTS[variant],
        className,
      )}
    >
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full', DOT[variant])} />}
      {children}
    </span>
  );
}
